import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'aftp-container',
  templateUrl: './aftp-container.component.html',
  styleUrls: ['./aftp-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AftpcontainerComponent {}
